var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("v-select", {
        staticClass: "soli-round soli-grey",
        attrs: {
          "prepend-inner-icon": "assignment",
          outlined: "",
          dense: "",
          "item-text": "name",
          "item-value": "name",
          value: _vm.value,
          "menu-props": "auto",
          items: _vm.roles,
          label: "Staff Role",
          disabled: _vm.disabled,
          clearable: _vm.clearable,
        },
        on: {
          input: function ($event) {
            return _vm.$emit("input", $event)
          },
        },
        scopedSlots: _vm._u([
          {
            key: "append-outer",
            fn: function () {
              return [
                _vm.help
                  ? _c(
                      "v-icon",
                      {
                        attrs: { color: "primary" },
                        on: {
                          click: function ($event) {
                            _vm.showPermissions = true
                          },
                        },
                      },
                      [_vm._v("help")]
                    )
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _vm.showPermissions
        ? _c("SoliForm", {
            attrs: {
              title: "Staff Permissions",
              hideBtn: "",
              noContainer: "",
              limitScroll: "",
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "body",
                  fn: function () {
                    return [
                      _c(
                        "v-container",
                        { staticClass: "pt-0 px-4" },
                        _vm._l(_vm.roles, function (role) {
                          return _c(
                            "v-list",
                            { key: role.id },
                            [
                              _c("div", [_vm._v(_vm._s(role.name))]),
                              _vm._v(" "),
                              _vm._l(role.permissions, function (permission) {
                                return _c(
                                  "div",
                                  { key: permission.name, staticClass: "px-3" },
                                  [
                                    _c("small", [
                                      _vm._v(_vm._s("-" + permission.name)),
                                    ]),
                                  ]
                                )
                              }),
                            ],
                            2
                          )
                        }),
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              3660805163
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }